var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-progress-bar'),_vm._v(" "),_c('vAlert',{attrs:{"type":_vm.alertData.type,"dismissable":"","duration":3000,"placement":"top","width":"90%"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(_vm._s(_vm.alertData.text))]),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }